export const CREATE_POI_PATH = '/custom-poi';
